export class BackToDashboardButtonController {
  constructor($state) {
    'ngInject';
    this.$state = $state;
  }

  get analytics() {
    const state = this.$state.$current.self;
    const analytics = state.analytics || {};

    return Object.assign({}, analytics.properties, {
      page: analytics.page || state.title,
    });
  }
}
